import { render, staticRenderFns } from "./CreateRelayAction.vue?vue&type=template&id=0a1bca56"
import script from "./CreateRelayAction.vue?vue&type=script&lang=js"
export * from "./CreateRelayAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports